import styled from 'styled-components';

export const CharacterImage = styled.img`
  position: absolute;
  bottom: 0;
  z-index: 200;
  width: auto;
  object-fit: contain;
`;
